<ng-container *ngIf="isModal; else useDiv">
    <mat-dialog-content>
        <div class="row">
            <ng-container *ngTemplateOutlet="contenido"></ng-container>
        </div>
    </mat-dialog-content>
</ng-container>

<ng-template #useDiv>
    <div class="main-container row p-5 mt-3 border">
        <ng-container *ngTemplateOutlet="contenido"></ng-container>
    </div>
</ng-template>

<ng-template #contenido>
    <div class="col-12">
        <div class="p-2 bg-success badge-pill">
            <h2 class="text-center font-weight-bold">{{ resultado?.resolucion || 'Sin información' }}</h2>
        </div>
        <div *ngIf=resultado?.mensaje class="mt-3 p-1 bg-success badge-pill">
            <h4 class="text-center font-weight-bold">{{ resultado?.mensaje }}</h4>
        </div>
    </div>

    <mat-card class="col-8 mt-5 mx-auto">
        <mat-card-content>
            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Rut:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">{{ datosBasicosSolicitud?.rut }}
                    </div>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Nombre:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">{{ basicReport?.InformacionBasica?.NombreORazonSocial }}</div>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Nacionalidad:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">{{ basicReport?.InformacionPersonal?.Nacionalidad }}</div>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Tipo de renta:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">{{ resultado?.tiporenta }}</div>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Renta declarada:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ rulesInput?.application?.income }}</div>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Renta actual:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ resultado?.rentaactual }}</div>
                </div>
                <div class="col-1 pl-0">
                    <!-- <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openInfoDialog(DIALOG_KEYS.RENTA_ACTUAL)">
                        <mat-icon>info</mat-icon>
                    </button> -->
                </div>
            </div>

            <div class="row mt-3 mb-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Tope:</label>
                </div>
                <div class="col-8 pr-0">
                    <div class="data-item rounded-pill text-center">{{ resultado?.montomaxUF }} UF</div>
                </div>
            </div>

        </mat-card-content>
    </mat-card>

    <mat-card class="col-8 mt-5 mx-auto">
        <mat-card-content>

            <div class="row">

                <div class="col-6 row mt-3 d-flex align-items-center">
                    <div class="col-4">
                        <label class="data-label">Vehículo:</label>
                    </div>
                    <div class="col-8">
                        <div class="data-item rounded-pill text-center">{{ rulesInput?.application?.carName }}</div>
                    </div>
                </div>

                <div class="col-6 row mt-3 d-flex align-items-center">
                    <div class="col-4">
                        <label class="data-label">Periodo:</label>
                    </div>
                    <div class="col-8">
                        <div class="data-item rounded-pill text-center">{{ periodDisplayText }}</div>
                    </div>
                </div>
            </div>

            <div class="row d-flex align-items-center">

                <div class="col-6 row mt-3">
                    <div class="col-4">
                        <label class="data-label">Valor:</label>
                    </div>
                    <div class="col-8">
                        <div class="data-item rounded-pill text-center">$ {{ vehicleValue }}</div>
                    </div>
                </div>

                <div class="col-6 row mt-3 mb-3">
                    <div class="col-4">
                        <label class="data-label">Km/año:</label>
                    </div>
                    <div class="col-8">
                        <div class="data-item rounded-pill text-center">{{ rulesInput?.application?.kilometers }}</div>
                    </div>
                </div>

            </div>

        </mat-card-content>
    </mat-card>

    <mat-card class="col-8 mt-5 mx-auto">
        <mat-card-content>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Carga:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">{{ (resultado?.carga ?? 0) * 100 | number:'1.0-0'}}%</div>
                </div>
                <div class="col-1 pl-0"></div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="cargaSemClass">{{ resultado?.mensajegarcarga }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Dicom:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ resultado?.deudamorosa | number:'1.0-0' }}</div>
                </div>
                <div class="col-1 pl-0">
                    <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openModalConsolidado()">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="deudaMorosaSemClass">{{ deudaMorosaSemDisplayText }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Regcheq:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">{{ regCheqDisplayText }}</div>
                </div>
                <div class="col-1 pl-0">
                    <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openModalRegCheq()">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="regCheqClass">{{ regCheqDisplayText }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Deuda TAG:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ tagReport?.Reporte?.debtTotal | number:'1.0-0' }}
                    </div>
                </div>
                <div class="col-1 pl-0">
                    <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openModalTag()">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="tagSemClass">{{ resultado?.tagratio | number:'1.2-2'  }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Línea Disponible:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ lastLineaCredito | number:'1.0-0' }}</div>
                </div>
                <div class="col-1 pl-0">
                    <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openModalConsolidado()">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="lineaBancariaSemClass">{{ resultado?.lineabancaria | number:'1.2-2' }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Deuda Total:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ resultado?.deudasbif | number:'1.0-0' }}</div>
                </div>
                <div class="col-1 pl-0">
                    <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openModalConsolidado()">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="deudaBancariaSemClass">{{ resultado?.deudabancaria | number:'1.2-2' }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Deuda sin hp:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ resultado?.deudasbifship | number:'1.0-0' }}</div>
                </div>
                <div class="col-1 pl-0">
                    <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openModalConsolidado()">
                        <mat-icon>info</mat-icon>
                    </button>
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="deudaSbifShipRentaSemClass">{{ resultado?.deudasbifshipRenta | number:'1.2-2' }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Continuidad Laboral:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">{{ antiguedadDisplayText }}</div>
                </div>
                <div class="col-1 pl-0">
                    <!-- <button
                        mat-icon-button
                        color="primary"
                        matTooltip="Ver detalle" 
                        [matTooltipPosition]="'right'"
                        (click)="openInfoDialog(DIALOG_KEYS.CONTINUIDAD_LABORAL)">
                        <mat-icon>info</mat-icon>
                    </button> -->
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="antiguedadSemClass">{{ antiguedadSemDisplayText }}</p>
                </div>
            </div>

            <div class="row mt-3 d-flex align-items-center">
                <div class="col-3">
                    <label class="data-label">Deuda Salfa:</label>
                </div>
                <div class="col-4 pr-0">
                    <div class="data-item rounded-pill text-center">$ {{ lastWrshb | number:'1.0-0' }}</div>
                </div>
                <div class="col-1 pl-0">
                </div>
                <div class="col-4">
                    <p class="data-item rounded-pill text-center" [ngClass]="deudaSalfaSemClass">{{ deudaSalfaSemDisplayText }}</p>
                </div>
            </div>

        </mat-card-content>
    </mat-card>

    <mat-card class="col-8 mt-5 mx-auto">
        <mat-card-header class="mb-4">
            <mat-card-title>Solicitudes</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="mat-table-container mb-4">
                <table mat-table [dataSource]="solicitudesDataSource">
                    <mat-text-column name="creacion"></mat-text-column>
                    <mat-text-column name="modelo"></mat-text-column>
                    <mat-text-column name="per" headerText="Per."></mat-text-column>
                    <mat-text-column name="kms" headerText="Kms."></mat-text-column>
                    <mat-text-column name="precio"></mat-text-column>
                    <mat-text-column name="estado"></mat-text-column>

                    <tr mat-header-row *matHeaderRowDef="solicitudesDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: solicitudesDisplayedColumns"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="solicitudesDisplayedColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="col-8 mt-5 mx-auto">
        <mat-card-header class="mb-4">
            <mat-card-title>Contratos</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="mat-table-container mb-4">
                <table mat-table [dataSource]="contratosDataSource">
                    <mat-text-column name="estado"></mat-text-column>
                    <mat-text-column name="creacion"></mat-text-column>
                    <mat-text-column name="valor"></mat-text-column>
                    <mat-text-column name="per" headerText="Per."></mat-text-column>

                    <tr mat-header-row *matHeaderRowDef="contratosDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: contratosDisplayedColumns"></tr>

                    <tr class="mat-mdc-row" *matNoDataRow>
                        <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="contratosDisplayedColumns.length">
                            No hay datos disponibles
                        </td>
                    </tr>
                </table>
            </div>
        </mat-card-content>
    </mat-card>

</ng-template>